import BaseController from "./base_controller"

export default class extends BaseController {
  static targets = ["input", "sum", "submitInput"]

  connect() {
    this.updateSumDisplay()
  }

  erase(event) {
    event.currentTarget.parentElement.querySelectorAll('input').forEach(input => { input.value = 0 })
    this.updateSumDisplay()
  }

  compute() {
    const sum = this.sum()
    this.updateSumDisplay(sum)
    if (this.hasSubmitInputTarget) this.submitInputTarget.disabled = sum !== 100
  }

  guardSubmit(event) {
    const sum = this.sum()
    if (sum === 100) return

    event.preventDefault()
    this.dispatchNotify(`Sum of Client Settings must amount to 100%. Currently it is: ${sum.toFixed(2)}%.`, { type: 'error' })
  }

  updateSumDisplay(sum = this.sum()) {
    if (!this.hasSumTarget) return
    this.sumTarget.value = sum.toFixed(2) + '%'
    this.sumTarget.classList.toggle('error', sum !== 100)
  }

  sum() {
    return this.inputTargets.reduce((total, input) => total + parseFloat(input.value), 0)
  }
}
